<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Customer <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  item-text="name"
                  item-value="id"
                  return-object
                  :items="customers"
                  v-model="customer"
                  @change="onChangeCustomer"
                  :rules="[v => !!v || 'Customer is required']"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Invoice Number <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="sequenceNumber"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Invoice From <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-radio-group v-model="form.type" row @change="onChangeType">
                  <v-radio label="PO" value="PO"></v-radio>
                  <v-radio label="DO" value="DO"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-row>
              <v-col cols="6" sm="6" md="2" lg="2" class="py-0">
                <v-subheader>PO Customer <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="6" sm="6" md="4" lg="4" class="py-0" v-if="form.type === 'DO'">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  return-object
                  item-text="purchaseOrderNumber"
                  v-model="purchaseOrder"
                  :items="salePurchaseOrders"
                  @change="onChangePurchaseOrder"
                  :rules="[v => !!v || 'PO is required']"
                >
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title>{{ data.item.purchaseOrderNumber }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6" md="4" lg="4" class="py-0" v-if="form.type === 'PO'">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  return-object
                  v-model="purchaseOrder"
                  :items="salePurchaseOrders"
                  :rules="[v => !!v || 'PO is required']"
                >
                  <template v-slot:selection="data">
                    {{ data.item.purchaseOrderNumber }} ({{ data.item.site }})
                  </template>
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ data.item.purchaseOrderNumber }} ({{
                            data.item.site
                          }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6" md="2" lg="2" class="py-0" v-if="form.type === 'PO'">
                <v-btn
                  v-if="$rbac.can('sale-invoice-bdo.create')"
                  color="success"
                  @click="addPurchaseOrder"
                  class="mr-2"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-btn color="primary" @click="viewTablePo">
                  <v-icon>
                    mdi-file-table-outline
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" v-if="form.type === 'DO'">
            <v-row>
              <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                <v-subheader>DO Customer <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  item-text="doNumber"
                  return-object
                  v-model="deliveryOrder"
                  :items="saleDeliveryOrders"
                  :rules="[v => !!v || 'DO is required']"
                >
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.doNumber"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" sm="6" md="2" lg="2" class="py-0" v-if="form.type === 'DO'">
                <v-btn
                  v-if="$rbac.can('sale-invoice-bdo.create')"
                  color="success"
                  @click="addDeliveryOrder"
                  class="mr-2"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-btn color="primary" @click="viewTableDo">
                  <v-icon>
                    mdi-file-table-outline
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Invoice Date <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuInvoiceDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.invoiceDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.invoiceDate"
                    @input="menuInvoiceDate = false"
                    @change="onInputInvoiceDuration"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Term</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.invoiceDuration"
                  suffix="days"
                  @change="onInputInvoiceDuration"
                  :rules="[v => v >= 0 || 'Term must more than equals 0']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader> Bill To<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  disabled
                  v-model="form.billTo"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Bill To Contact</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.billToContact"
                  :items="contacts"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Percentage Invoice<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="form.percentageInvoice"
                  suffix="%"
                  @change="onInputPercentageInvoice"
                  :rules="percentageInvoiceRules"
                  v-if="form.type === 'PO'"
                ></v-text-field>
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="form.percentageInvoice"
                  suffix="%"
                  @change="onInputPercentageInvoice"
                  :rules="percentageInvoiceRules"
                  v-if="form.type === 'DO'"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>PPN</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="form.percentagePpn"
                  suffix="%"
                  @change="onInputPercentagePpn"
                  :rules="[v => v >= 0 || 'PPN must more than equals 0']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Rate</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.rate"
                  prefix="Rp."
                  :rules="[v => v >= 1 || 'Rate must more than equals 1']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="form.percentagePpn > 0">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-checkbox v-model="form.fp" label="Faktur Pajak Digunggung"></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="form.percentagePpn > 0 && !form.fp">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-row>
              <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                <v-subheader>Tax Invoice Serial Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <!-- <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.taxInvoiceSerialNumber"
                ></v-text-field> -->
                <v-row>
                  <v-col cols="3">
                    <v-select
                      dense
                      outlined
                      flat
                      background-color="white"
                      :items="arrayFronts"
                      v-model="twoDigit"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      dense
                      outlined
                      flat
                      background-color="white"
                      :items="arrayFrontNexts"
                      v-model="oneDigit"
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="serialNumber.number"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Remark</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-textarea
                  outlined
                  flat
                  rows="3"
                  background-color="white"
                  v-model="form.remark"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Discount</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <span>{{ form.discount }}%</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-tabs vertical>
              <v-tab background-color="light-blue accent-3" dark class="px-0">
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab>
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6"></v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">
                        Item Detail <span class="red--text">*</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRow"
                      >
                        <template v-slot:item.no="{ item }">
                          {{ items.map(x => x).indexOf(item) + 1 }}
                        </template>
                        <template v-slot:item.unitPrice="{ item }">
                          {{ formatPrice(item.unitPrice) }}
                        </template>
                        <template v-slot:item.total="{ item }">
                          {{ formatPrice(item.total) }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-title class="font-italic">Additional Info</v-card-title>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="pb-0">
                      <v-subheader>Due Date</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="pb-0">
                      <span>{{ form.invoiceDueDate }}</span>
                    </v-col>
                    <v-col cols="4" sm="4" md="2" lg="2" class="pb-0">
                      <v-subheader>Currency</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="pb-0">
                      <span>{{ form.currency }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>Percent Up To This Invoice</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <span>{{ form.percentageUpTo }}%</span>
                    </v-col>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>Site</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <span>{{ form.site }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>Sales</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <span>{{ form.salesName }}</span>
                    </v-col>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>PO Number</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <span>{{ purchaseOrder ? purchaseOrder.purchaseOrderNumber : "" }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
                      <v-subheader>DP Percentage</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
                      <span>{{ totalPercentage }}%</span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">Sub Total</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{
                  formatPrice(form.type === "DO" ? totalPoAmount : form.totalAmount)
                }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">Total Invoice</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(form.totalAmountAfterInvoice) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">PPH</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(form.pphAmount) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2" v-if="form.percentagePpn > 0">
            <v-card outlined>
              <v-card-title class="py-0">Tax</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(form.taxAmount) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title class="py-0">Total After Tax</v-card-title>
              <v-card-text class="text-right mt-3">
                <span>{{ formatPrice(form.totalAmountAfterTax) }}</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1" class="py-0">
        <v-row class="py-0">
          <v-col cols="12" class="mb-4 py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('sale-invoice-bdo.create')"
                  color="primary"
                  v-on="on"
                  @click="checkJournal"
                >
                  <v-icon large>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-sale-product
      :item="item"
      :index="index"
      :dialog="dialog"
      :accounts="accounts"
      @save="saveItem"
      @close="close"
      @deleteItem="deleteItem"
    ></dialog-sale-product>
    <dialog-view-table
      :dialog="dialogTablePo"
      :purchaseOrders="form.purchaseOrders"
      @close="close"
      @deleteItem="deleteItemTablePo"
      type="PO"
    ></dialog-view-table>
    <dialog-view-table
      :dialog="dialogTableDo"
      :deliveryOrders="form.deliveryBdos"
      @close="close"
      @deleteItem="deleteItemTableDo"
      type="DO"
    ></dialog-view-table>
    <dialog-confrim :dialog="dialogAlert" @reset="resetInput" @close="close"></dialog-confrim>
    <dialog-review-journal
      :dialog="dialogReview"
      :journals="journals"
      @save="submit"
      @close="close"
      currency="IDR"
    ></dialog-review-journal>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogSaleProduct from "@/components/DialogSaleProduct";
import DialogViewTable from "@/components/DialogViewTable";
import DialogConfrim from "@/components/DialogConfrim";
import DialogReviewJournal from "@/components/DialogReviewJournal";

export default {
  name: "create-sale-invoice",
  components: {
    "dialog-sale-product": DialogSaleProduct,
    "dialog-view-table": DialogViewTable,
    "dialog-confrim": DialogConfrim,
    DialogReviewJournal,
  },
  data: () => ({
    defaultForm: {
      formNumber: "",
      invoiceNumber: "",
      invoiceDate: moment().format("yyyy-MM-DD"),
      invoiceDueDate: moment().format("yyyy-MM-DD"),
      invoiceDuration: 0,
      siteId: 0,
      customerId: null,
      customerName: null,
      customerAddress: null,
      type: "DO",
      salesName: "",
      percentageInvoice: 0,
      percentageDownPayment: 0,
      percentagePaid: 0,
      percentagePpn: 11,
      currency: "",
      site: "",
      percentageUpTo: 0,
      discount: 0,
      billTo: "",
      billToContact: "",
      taxInvoiceSerialNumber: "",
      materialDocumentNumber: "",
      totalAmount: 0,
      rate: 1,
      taxAmount: 0,
      pphAmount: 0,
      totalAmountAfterInvoice: 0,
      totalAmountAfterTax: 0,
      totalDownPayment: 0,
      products: [],
      fp: false,
      taxId: null,
      status: "Outstanding",
      deliveryBdos: [],
      purchaseOrders: [],
      downPaymentPercentageDtos: [],
    },
    menuInvoiceDate: false,
    form: {},
    items: [],
    customer: null,
    purchaseOrder: null,
    deliveryOrder: null,
    saleDeliveryOrders: [],
    salePurchaseOrders: [],
    accounts: [],
    journals: [],
    dialog: false,
    dialogTablePo: false,
    dialogTableDo: false,
    dialogAlert: false,
    dialogReview: false,
    item: {},
    index: -1,
    twoDigit: "01",
    oneDigit: 0,
    arrayFronts: ["01", "02", "03", "04", "05", "06", "07", "08", "09"],
    arrayFrontNexts: [0, 1],
    valid: true,
    listTotalAmount: [],
    headers: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Product Detail",
        value: "partDesc",
        sortable: false,
        divider: true,
      },
      {
        text: "Qty",
        value: "quantity",
        sortable: false,
        divider: true,
      },
      {
        text: "U/M",
        value: "unitMeasure",
        sortable: false,
        divider: true,
      },
      {
        text: "U/Price",
        value: "unitPrice",
        sortable: false,
        divider: true,
      },
      {
        text: "Disc %",
        value: "discount",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "total",
        sortable: false,
        divider: true,
      },
      {
        text: "Line Item",
        value: "lineItem",
        sortable: false,
        divider: true,
      },
      {
        text: "Part#",
        value: "partNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "PO#",
        value: "poNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "DO#",
        value: "doNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Mat Doc#",
        value: "materialDocumentNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Account",
        value: "accountName",
        sortable: false,
        divider: true,
      },
    ],
  }),

  computed: {
    totalAmount() {
      let subtotal = 0;
      this.items.map(key => {
        subtotal = subtotal + key.total;
      });
      return subtotal - subtotal * (this.form.discount / 100);
    },
    totalPoAmount() {
      let subtotal = 0;
      if (this.form.type === "DO") {
        if (this.form.purchaseOrders.length > 0 && this.form.purchaseOrders) {
          this.form.purchaseOrders[0].products.map(key => {
            subtotal = subtotal + key.total;
          });
        }
      }
      return subtotal - subtotal * (this.form.discount / 100);
    },
    pphAmount() {
      let subtotal = 0;
      this.items.map(key => {
        subtotal = subtotal + key.pph23Amount;
      });
      return subtotal;
    },
    ...mapState("external", ["customers", "contacts"]),
    ...mapState("saleInvoice", ["lastFormNumber", "sequenceNumber", "lastPercentage"]),
    ...mapState("saleDownPayment", ["totalPercentageDownPayment"]),
    ...mapState("taxNumber", ["serialNumber"]),
    percentageInvoiceRules() {
      const total = this.totalPercentage;
      return [
        v => !!v || "Percentage invoice is required",
        v =>
          (v <= 100 - total && v >= 1) ||
          `Percentage invoice must be more than 1 and less than ${100 - total}`,
      ];
    },
    totalPercentage() {
      let total = 0;
      this.totalPercentageDownPayment.forEach(x => {
        total += x.percentage;
      });
      return total;
    },
  },

  watch: {
    totalAmount(val) {
      this.form.totalAmount = val;
      if (this.form.type === "DO") {
        this.form.totalAmountAfterInvoice = (val * this.form.percentageInvoice) / 100;
        this.form.taxAmount = (this.form.totalAmountAfterInvoice * this.form.percentagePpn) / 100;
        this.form.pphAmount = (this.pphAmount * this.form.percentageInvoice) / 100;
        this.form.totalAmountAfterTax =
          this.form.totalAmountAfterInvoice + this.form.taxAmount - this.form.pphAmount;
      }
    },
    pphAmount(val) {
      this.form.pphAmount = val;
    },
  },

  methods: {
    checkJournal() {
      if (this.form.type === "PO") {
        this.onInputPercentageInvoice();
      } else {
        this.form.totalAmountAfterInvoice = (this.totalAmount * this.form.percentageInvoice) / 100;
        this.form.taxAmount = (this.form.totalAmountAfterInvoice * this.form.percentagePpn) / 100;
        this.form.pphAmount = (this.pphAmount * this.form.percentageInvoice) / 100;
        this.form.totalAmountAfterTax =
          this.form.totalAmountAfterInvoice + this.form.taxAmount - this.form.pphAmount;
      }
      if (this.$refs.form.validate() && this.items.length > 0) {
        this.journals = [
          {
            accountName: `${this.form.customerName} ${this.form.currency}`,
            debit: this.form.totalAmountAfterTax,
            credit: 0,
          },
        ];
        this.totalPercentageDownPayment.forEach(x => {
          this.journals.unshift({
            accountName: `UANG MUKA PENJUALAN ${this.form.currency}`,
            debit: this.totalAmount * (x.percentage / 100.0),
            credit: 0,
          });
        });
        let map = this.items.map(x => x.accountName);
        let array = map.filter((v, i, a) => a.indexOf(v) === i);
        array.forEach(y => {
          let total = 0;
          this.items.forEach(x => {
            if (x.accountName === y) {
              total += x.total * (this.form.percentageInvoice / 100);
            }
          });
          this.journals.push({
            accountName: `${y}`,
            debit: 0,
            credit: total,
          });
        });
        if (this.form.taxAmount > 0) {
          this.journals.push({
            accountName: `HUTANG PPN KELUARAN`,
            debit: 0,
            credit: this.form.taxAmount,
          });
        }
        if (this.form.pphAmount > 0) {
          this.journals.unshift({
            accountName: `PAJAK PPH - 23`,
            debit: this.form.pphAmount,
            credit: 0,
          });
        }
        this.dialogReview = true;
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Items is required",
        });
      }
    },
    submit() {
      if (this.$refs.form.validate() && this.items.length > 0) {
        this.form.invoiceNumber = this.sequenceNumber;
        this.form.formNumber = this.lastFormNumber;
        this.form.taxInvoiceSerialNumber = this.form.fp
          ? ""
          : this.twoDigit + this.oneDigit + "." + this.serialNumber.number;
        this.form.products = this.items;
        this.form.taxId = this.serialNumber.id;
        this.form.percentageDownPayment = this.totalPercentage;
        this.form.totalDownPayment = (this.totalPercentage / 100) * this.totalAmount;
        this.form.downPaymentPercentageDtos = this.totalPercentageDownPayment;

        let totalDebit =
          this.form.totalDownPayment + this.form.totalAmountAfterTax + this.form.pphAmount;
        let totalCredit = this.form.taxAmount + this.totalAmount;

        if (totalDebit - totalCredit === 0) {
          this.$store.commit("SET_LOADER", true);
          this.$store
            .dispatch("saleInvoice/create", this.form)
            .then(() => {
              this.clear();
              this.$store.commit("SET_LOADER", false);
            })
            .catch(() => {
              this.$store.dispatch("toast", {
                type: "error",
                message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
              });
              this.$store.commit("SET_LOADER", false);
            });
        } else {
          let different = totalDebit - totalCredit;
          if (different > 0) {
            this.$store.dispatch("toast", {
              type: "error",
              message: `Journal not balance with -${Math.abs(different)} on Debit`,
            });
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: `Journal not balance with -${Math.abs(different)} on Credit`,
            });
          }
        }
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Items is required",
        });
      }
    },
    async onChangeCustomer(val) {
      this.form.customerId = val.id;
      this.form.customerName = val.name;
      this.form.billTo = val.name;
      this.getAdditionalDataFromCustomerId(val.id);
    },
    getAdditionalDataFromCustomerId(id) {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("external/getSalePurchaseOrders", id)
        .then(response => {
          this.salePurchaseOrders = response.data;
          this.$store
            .dispatch("external/getContact", id)
            .then(() => this.$store.commit("SET_LOADER", false))
            .catch(() => {
              this.$store.dispatch("toast", {
                type: "error",
                message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
              });
              this.$store.commit("SET_LOADER", false);
            });
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    invoiceDueDate() {
      let dueDate = moment(this.form.invoiceDate)
        .add(this.form.invoiceDuration, "days")
        .format("yyyy-MM-DD");
      return dueDate;
    },
    onInputInvoiceDuration() {
      this.form.invoiceDueDate = this.invoiceDueDate();
    },
    onChangeType(val) {
      if (val === "PO") {
        this.form.percentageInvoice = 0;
      } else {
        this.form.percentageInvoice = 100;
      }
      this.dialogAlert = true;
    },
    resetInput() {
      this.purchaseOrder = null;
      this.deliveryOrder = null;
      this.form.purchaseOrders = [];
      this.form.deliveryBdos = [];
      this.items = [];
      this.form.site = "";
      this.form.purchaseOrderId = null;
      this.form.purchaseOrderNumber = "";
      this.form.purchaseOrderCustomer = "";
      this.form.customerAddress = "";
      this.form.salesName = "";
      this.form.currency = "";
      this.form.billToContact = null;
      this.form.totalAmountAfterInvoice = 0;
      this.form.taxAmount = 0;
      this.form.totalAmountAfterTax = 0;
      this.form.percentagePaid = 0;
      this.form.percentageUpTo = 0;
    },
    async addPurchaseOrder() {
      if (this.purchaseOrder == null) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "PO number belum dipilih",
        });
      } else {
        if (this.form.purchaseOrders.length > 0) {
          if (
            this.form.purchaseOrders[0].purchaseOrderNumber ===
            this.purchaseOrder.purchaseOrderNumber
          ) {
            if (this.form.purchaseOrders.indexOf(this.purchaseOrder) !== -1) {
              this.$store.dispatch("toast", {
                type: "error",
                message: "PO sudah dipakai pada form",
              });
            } else {
              this.form.purchaseOrders.push(this.purchaseOrder);
              this.items = this.items.concat(this.purchaseOrder.products);
              this.form.site = this.form.purchaseOrders.map(x => x.site).join(",");
              this.form.discount = this.purchaseOrder.discount;
            }
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: "PO number tidak sama",
            });
          }
        } else {
          this.form.purchaseOrders.push(this.purchaseOrder);
          this.items = this.items.concat(this.purchaseOrder.products);
          this.form.salesName = this.purchaseOrder.user.name;
          this.form.customerAddress = this.purchaseOrder.address.street;
          this.form.currency = this.purchaseOrder.currency;
          this.form.billToContact = this.purchaseOrder.contact.id;
          this.form.site = this.form.purchaseOrders.map(x => x.site).join(",");
          this.form.discount = this.purchaseOrder.discount;
        }
        this.$store.commit("SET_LOADER", true);
        Promise.all([
          this.$store.dispatch("saleDownPayment/totalDownPayment", this.purchaseOrder.id),
          this.$store.dispatch("saleInvoice/getPercentagePaid", this.purchaseOrder.id),
        ])
          .then(() => this.$store.commit("SET_LOADER", false))
          .catch(() => {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
            });
            this.$store.commit("SET_LOADER", false);
          });
      }
    },
    viewTablePo() {
      this.dialogTablePo = true;
    },
    deleteItemTablePo(item) {
      const index = this.form.purchaseOrders.map(x => x).indexOf(item);
      if (index > -1) {
        this.form.purchaseOrders.splice(index, 1);
        item.products.forEach(x => {
          const index = this.items.indexOf(x);
          if (index >= 0) this.items.splice(index, 1);
        });
        this.form.site = this.form.purchaseOrders.map(x => x.site).join(",");
      }
    },
    addDeliveryOrder() {
      if (this.deliveryOrder == null) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "DO belum dipilih",
        });
      } else {
        if (this.form.deliveryBdos.indexOf(this.deliveryOrder) !== -1) {
          this.$store.dispatch("toast", {
            type: "error",
            message: "DO sudah dipakai pada form",
          });
        } else {
          this.items = this.items.concat(this.deliveryOrder.products);
          this.form.deliveryBdos.push(this.deliveryOrder);
          this.form.salesName = this.purchaseOrder.user.name;
          this.percentageUpTo();
        }
      }
    },
    viewTableDo() {
      this.dialogTableDo = true;
    },
    deleteItemTableDo(item) {
      const index = this.form.deliveryBdos.map(x => x).indexOf(item);
      if (index > -1) {
        this.form.deliveryBdos.splice(index, 1);
        this.$store
          .dispatch("external/getSaleDeliveryOrdersDetail", item.id)
          .then(response => {
            let total = 0;
            response.data.forEach(x => {
              total += x.total;
              const index = this.items.findIndex(y => y.doNumber === item.name);
              if (index > -1) this.items.splice(index, 1);
            });
            let percentage = (total / this.totalPoAmount) * 100;
            this.form.percentageUpTo -= percentage;
            this.form.percentagePaid -= percentage;
            this.$store.commit("SET_LOADER", false);
          })
          .catch(() => {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
            });
            this.$store.commit("SET_LOADER", false);
          });
      }
    },
    async onChangePurchaseOrder(val) {
      this.$store.commit("SET_LOADER", true);
      this.form.customerAddress = val.address.street;
      this.form.salesName = val.salesName;
      this.form.currency = val.currency;
      this.form.site = val.site;
      this.form.billToContact = val.contact.id;
      this.form.purchaseOrders.push(this.purchaseOrder);
      this.$store
        .dispatch("billingDO/getListBillingDO", val.id)
        .then(response => {
          this.saleDeliveryOrders = response.data;
          Promise.all([
            this.$store.dispatch("saleDownPayment/totalDownPayment", this.purchaseOrder.id),
            this.$store.dispatch("saleInvoice/getPercentagePaid", this.purchaseOrder.id),
          ])
            .then(() => {
              this.form.percentageInvoice = 100 - this.totalPercentage;
              this.$store.commit("SET_LOADER", false);
            })
            .catch(() => {
              this.$store.dispatch("toast", {
                type: "error",
                message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
              });
              this.$store.commit("SET_LOADER", false);
            });
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    percentageUpTo() {
      this.form.percentagePaid =
        ((this.totalAmount * (this.form.percentageInvoice / 100)) / this.totalPoAmount) * 100;
      if (this.form.type === "DO") {
        this.form.percentageUpTo =
          parseFloat(this.lastPercentage) +
          parseFloat(this.totalPercentage) +
          this.form.percentagePaid;
      }
    },
    onInputPercentageInvoice() {
      this.form.totalAmountAfterInvoice = this.totalAmount * (this.form.percentageInvoice / 100);
      this.form.taxAmount = this.form.totalAmountAfterInvoice * (this.form.percentagePpn / 100);
      this.form.pphAmount = this.pphAmount * (this.form.percentageInvoice / 100);
      this.form.totalAmountAfterTax =
        this.form.totalAmountAfterInvoice + this.form.taxAmount - this.form.pphAmount;
      this.form.percentagePaid = (this.totalAmount / this.totalPoAmount) * 100;
      this.form.percentageUpTo =
        this.lastPercentage + this.totalPercentage + this.form.percentagePaid;
    },
    onInputPercentagePpn() {
      this.form.taxAmount = this.form.totalAmountAfterInvoice * (this.form.percentagePpn / 100);
      this.form.totalAmountAfterTax = this.form.totalAmountAfterInvoice + this.form.taxAmount;
    },
    onClickRow(item) {
      this.item = item;
      this.index = this.items.map(x => x).indexOf(item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogAlert = false;
      this.dialogTablePo = false;
      this.dialogTableDo = false;
      this.dialogReview = false;
    },
    saveItem(data) {
      this.items[data.index] = data.item;
      this.close();
    },
    deleteItem(index) {
      if (index > -1) {
        this.items.splice(index, 1);
        this.dialog = false;
      }
    },
    clear() {
      this.customer = null;
      this.deliveryOrder = null;
      this.purchaseOrder = null;
      this.items = [];
      this.form = Object.assign({}, this.defaultForm);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async getAccounts() {
      const response = await this.$store.dispatch("chartOfAccount/getAccounts");
      if (response.status === 200) {
        this.accounts = response.data;
      }
    },
    getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        this.$store.dispatch("taxNumber/getNumber"),
        this.$store.dispatch("saleInvoice/getSequenceNumber"),
        this.$store.dispatch("saleInvoice/getLastFormNumber"),
        this.$store.dispatch("external/getCustomers"),
        this.getAccounts(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },

  mounted() {
    this.getInitialData();
    this.form = Object.assign({}, this.defaultForm);
  },
  beforeMount() {
    this.form.percentagePpn = JSON.parse(localStorage.getItem("setting_tax") || []).find(
      x => x.name === "PPN"
    ).percentage;
  },
};
</script>

<style></style>
